import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import RideMeSPA from './component/RideMeSPA';
import TermsAndConditions from './component/TermsAndConditions';
import PrivacyPolicy from './component/PrivacyPolicy'; 
import HowItWorks from './component/HowItWorks'; 

function App() {
  return (
    <Router>
          <Routes>
            <Route path="/" element={<RideMeSPA />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
          </Routes>


    </Router>
  );
}

export default App;